import { rootUrl } from '@/constants';
import axios from 'axios';

export type SubmitAuthorize = {
  email: string;
  otp: string;
  verificationCode: string;
};

export type ResponseAuthorize = {
  isAuthorized: boolean;
  token: string;
};

export const authorize = async (data: SubmitAuthorize) => {
  const response = await axios.post(
    `${rootUrl}/psychologist/authorize`,
    {
      email: data.email,
      otp: data.otp,
      verificationCode: data.verificationCode,
    },
    { withCredentials: true }
  );

  return response.data;
};
